import { gql } from '@apollo/client';

export const GET_PERMISSION_PACKAGE_LISTING = gql`
  query GetPermissionPackageListing(
    $condition: PermissionPackageQueryConditionInput
    $pageRequest: PageRequestTypeInput
  ) {
    getPermissionPackageListing: queryPermissionPackageByPage(
      condition: $condition
      pageRequest: $pageRequest
    ) {
      content {
        id
        name
        description
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export interface PermissionPackageType {
  id: string;
  name: string;
  description: string | null;
}

export interface PermissionPackageFiltersInput {
  id?: number;
  name?: string;
  description?: string;
}

export interface PermissionPackagePageResponseType {
  content: PermissionPackageType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface GetPermissionPackageListingResponse {
  getPermissionPackageListing: PermissionPackagePageResponseType;
}
